export default [
    {
      name: 'geral',
      options: [
        'Internet Cafe',
        'Library',
        'Shopping Center',
        'Employment Agency',
        'Tourist Information Center',
        'Travel Agency'
      ]
    },
    {
      name: 'Automotive',
      options: [
        'Automotive Business',
        'Auto Body Shop',
        'Auto Dealer',
        'Auto Parts Store',
        'Auto Rental',
        'Auto Repair',
        'Auto Wash',
        'Gas Station',
        'Motorcycle Dealer',
        'Motorcycle Repair'
      ]
    },
    {
      name: 'Emergency',
      options: [
        'Emergency Service',
        'Fire Station',
        'Hospital',
        'Police Station',
      ]
    },
    {
      name: 'Entertainment',
      options: [
        'Entertainment Business',
        'Adult Entertainment',
        'Amusement Park',
        'Art Gallery',
        'Casino',
        'Comedy Club',
        'Movie Theater',
        'Night Club'
      ]
    },
    {
      name: 'Financial',
      options: [
        'Accounting Service',
        'Automated Teller',
        'Bank Or Credit Union',
        'Insurance Agency',
      ]
    },
    {
      name:"Food",
      options: [
        'Food Establishment',
        'Bakery',
        'Bar Or Pub',
        'Brewery',
        'Cafe Or Coffee Shop',
        'Fast Food Restaurant',
        'Ice Cream Shop',
        'Restaurant',
        'Winery'
      ]
    },{
      name: "Health And Beauty",
      options: [
        'Health And Beauty Business',
        'Beauty Salon',
        'Day Spa',
        'Hair Salon',
        'Health Club',
        'Nail Salon',
        'Tattoo Parlor',
      ]
    }
    ,{
      name: "Home And Construction",
      options: [
        'Home And Construction Business',
        'Electrician',
        'General Contractor',
        'HVAC Business',
        'House Painter',
        'Locksmith',
        'Moving Company',
        'Plumber',
        'RoofingContractor',
      ]
    }
    ,{
      name: "Lodging",
      options: [
        'Lodging Business',
        'Bed And Breakfast',
        'Hostel',
        'Hotel',
        'Motel',
      ] 
    }
    ,{
      name: "Medical/Dental",
      options: [
        'Dentist',
        'Diagnostic Lab',
        'Hospital',
        'Medical Clinic',
        'Optician',
        'Pharmacy',
        'Physician',
        'Veterinary Care',
      ]
    }
    ,{
      name: "Professional Services",
      options: [
        'Professional Service',
        'Accounting Service',
        'Attorney',
        'Dentist',
        'Electrician',
        'General Contractor',
        'House Painter',
        'Locksmith',
        'Notary',
        'Plumber',
        'Roofing Contractor',
      ]
    }
    ,{
      name: "Sports Activities",
      options: [
        'Sports Activity Location',
        'Bowling Alley',
        'Exercise Gym',
        'Golf Course',
        'Health Club',
        'Public Swimming Pool',
        'Ski Resort',
        'Sports Club',
        'Stadium Or Arena',
        'Tennis Complex',
      ]
    },
    {
    name: "Stores",
    options: [
      'Store',
      'Auto Parts Store',
      'Bike Store',
      'Book Store',
      'Clothing Store',
      'Computer Store',
      'Convenience Store',
      'Department Store',
      'Electronics Store',
      'Florist',
      'Furniture Store',
      'Garden Store',
      'Grocery Store',
      'Hardware Store',
      'Hobby Shop',
      'Home Goods Store',
      'Jewelry Store',
      'Liquor Store',
      'Mens Clothing Store',
      'Mobile Phone Store',
      'Movie Rental Store',
      'Music Store',
      'Office Equipment Store',
      'Outlet Store',
      'Pawn Shop',
      'Pet Store',
      'Shoe Store',
      'Sporting Goods Store',
      'Tire Shop',
      'Toy Store',
      'Wholesale Store'
    ]
  }
]